export const productSubcategory = {
  ['LC_Perm_RI_SPFU_BPI']: 'immediate mass',
  ['LC_Nuevas_Adv_BPI']: 'immediate advance',
  ['LC_Perm_RI_SPFU_Prem_BPI']: 'immediate premier',
  ['LC_Perm_RevIni_SPFU_BPI']: 'lc perm revini spfu bpi',
  ['LC_Perm_RS_SPFU']: 'refill mass',
  ['Sub_Rev_OH']: 'refill ohc',
  ['LC_Perm_RS_Adva_BPI']: 'refill advance',
  ['LC_Perm_RS_Premier_BPI']: 'refill premier',
  ['LC_Recom_Rev_Adva_BPI']: 'lc recom rev adva bpi',
  ['LC_Recom_Rev_Premier_BPI']: 'lc recom rev premier bpi',
  ['Nva_Rev_OH']: 'nva rev oh',
  ['Simple_Nom_M']: 'simple mass',
  ['Simple_CP_M']: 'simple mass',
  ['Simple_Nom_A']: 'simple advance',
  ['Simple_CP_A']: 'simple advance',
  ['Simple_Nom_P']: 'simple premier',
  ['Simple_CP_P']: 'simple premier',
  ['Simple_CP']: 'simple cp',
  ['Simple_Nom']: 'simple nom',
  ['Simple_Nom_Saldos_P']: 'simple nom saldos p',
  ['Nva_TopUp']: 'top up',
  ['Nva_TopUp_CP']: 'nva topup cp',
  ['TopUp_AN_MB']: 'topup an mb',
  ['TopUp_CP_MB']: 'topup cp mb',
  ['Simple_Nom_Mob']: 'simple payroll',
  ['Simple_CP_Mob']: 'simple cp',
  ['Pasivos_AN_Mob']: 'simple payroll',
  ['Pasivos_CP_Mob']: 'simple cp',
  ['TopUp_AN_Mob']: 'top up payroll',
  ['TopUp_CP_Mob']: 'top up cp',
  ['Refill_Nom_Mob']: 'refill payroll',
  ['Refill_CP_Mob']: 'refill cp',
  ['Simple_MenoresCP_Mob']: 'simple cp',
  ['Simple_MenoresAN_Mob']: 'simple payroll',
};
